import React from 'react'

export function CustomerAccountCreditsListStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`

        /* Over riding messagebox style */
        .modal-content-container.message-box {
          margin: 5% auto;
        }

        /* CREDIT ACCOUNT LIST */
        .customer-accounts-credits-list-container {
          display: flex;
          flex-direction: column;
          margin-top: 20px;
          justify-content: stretch;
          font-size: 1rem;
          border: solid 1px lightblue;
        }

        .customer-accounts-credits-list-table {
          margin-top: 5px;
          font-size: 1rem;
          border: solid 1px lightblue;
          border-spacing: 0;
        }

        .customer-accounts-credits-list-table th, td {
          padding: 5px;
        }

        .customer-accounts-list-title {
          font-size: 1rem;
          padding: 10px;
        }

        .tbody-tr:hover {
          cursor: pointer;
          background-color: rgba(115, 125, 115, 0.8);
          color: white;
        }

        .status {
          border-radius: 3px;
          padding: 3px;
          text-align: center;
          color: white;
        }
        .unsettled { background-color: red; }
        .settled { background-color: blue; }
        .on-process { background-color: green; }
      `}
      </style>
    </React.Fragment>
  )
}

export function CustomerAccountCustomerDetailsStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        .customer-account-item-details-container {
          border: solid 1px lightblue;
          padding: 10px;
          font-size: 1rem;
        }

        .label-content-container {
          display: flex;
        }

        .label-content-container label {
          font-weight: bold;
          flex: 2;
        }

        .label-content-container div {
          flex: 5;
        }

        #credit-limit-container {
          display: flex;
        }
      `}
      </style>
    </React.Fragment>
  )
}

export function CustomerLogStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        .log-container {
          font-size: 0.8rem;
          margin-top: 10px;
          border-top: dotted 0.3px black;
        }
      `}
      </style>
    </React.Fragment>
  )
}
